import React from 'react';
import ModernCrossSell from './ModernCrossSell';
import styles from './ModernCrossSells.module.sass';

export default function ModernCrossSells({ onChange, crossSells, offers, offer }) {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h3>Popular Add-ons</h3>
        <p>Customers who bought this item also bought:</p>
      </div>
      <div className={styles.list}>
        {crossSells.map((item, index) => (
          <ModernCrossSell key={index} offers={offers} crossSell={item} onChange={onChange} offer={offer} />
        ))}
      </div>
    </div>
  );
}
